import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import Fab from '@material-ui/core/Fab';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Zoom from '@material-ui/core/Zoom';
import {animateScroll as scroll} from 'react-scroll';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
}));

function ScrollTop(props) {
  const { children, window } = props;
  const classes = useStyles();

  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    scroll.scrollToTop();
  };

  return (
    <Zoom in={trigger}>
      <div onClick={handleClick} 
      className={classes.root}>
        {children}
      </div>
    </Zoom>
  );
}

export default function BackToTop(props) {
  return (
    <React.Fragment>     
      <ScrollTop {...props}>
        <Fab size="small" style={{color: '#e4e4e4'}}>
          <KeyboardArrowUpIcon style={{color: '#231f20'}}/>
        </Fab>
      </ScrollTop>
    </React.Fragment>
  );
}
